import React from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { Globe } from "lucide-react";
import { LANGUAGES } from "@/i18n/translations";
import { useLang } from "@/context/LanguageContext";

export default function LanguageSheet() {
  const { lang, setLang, t } = useLang();
  const [open, setOpen] = React.useState(false);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <button
          data-testid="nav-language-selector-btn"
          className="flex items-center gap-2 px-3 py-2 rounded-full border border-gold hover:border-gold-active transition text-ivory text-xs uppercase tracking-widest"
        >
          <Globe size={14} className="text-gold-hi" />
          <span className="hidden sm:inline">{LANGUAGES.find((l) => l.code === lang)?.native}</span>
        </button>
      </SheetTrigger>
      <SheetContent
        side="bottom"
        data-testid="language-selector-modal"
        className="bg-obsidian border-t border-gold text-ivory rounded-t-3xl max-h-[80vh]"
      >
        <SheetHeader>
          <SheetTitle className="font-serif-lux text-2xl text-gold-hi tracking-wider">
            {t("lang.choose")}
          </SheetTitle>
        </SheetHeader>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mt-6 pb-8">
          {LANGUAGES.map((l) => (
            <button
              key={l.code}
              data-testid={`lang-option-${l.code}`}
              onClick={() => {
                setLang(l.code);
                setOpen(false);
              }}
              className={`px-4 py-4 rounded-xl border transition text-left ${
                lang === l.code
                  ? "border-gold-active bg-card-elev text-gold-hi"
                  : "border-gold text-ivory hover:bg-card-warm"
              }`}
            >
              <div className="text-lg font-medium">{l.native}</div>
              <div className="text-xs text-muted-warm mt-0.5">{l.name}</div>
            </button>
          ))}
        </div>
      </SheetContent>
    </Sheet>
  );
}
